export type DeviceNodeTypeEnum = 'Ground' | 'Air';

export const DeviceNodeType = {
  Ground: 'Ground',
  Air: 'Air',
} as const satisfies Record<string, DeviceNodeTypeEnum>;

export type DeviceCoordinate = {
  latitude: number | null;
  longitude: number | null;
};

export type DeviceCheckpoint = {
  coordinate: DeviceCoordinate | null;
  isComplete: boolean;
};

export type DeviceDepartureTime = {
  std: string | null;
  atd: string | null;
  ptd: string | null;
};

export type DeviceArrivalTime = {
  sta: string | null;
  eta: string | null;
  pta: string | null;
};

export type DevicePlannedPolyline = {
  polyline: string | null;
  etag: string | null;
  skippedPolylinePointsInSameEtag: number | null;
};

export type DeviceTrackedPolyline = {
  polyline: string | null;
  nextPolylineOffset: number | null;
};

export type DeviceCurrentPosition = {
  coordinate: DeviceCoordinate;
  heading: number;
  timestamp: string;
};

export type DeviceNode = {
  nodeType: DeviceNodeTypeEnum;
  legId: string;
  nodeId: string;
  groundTripId: string | null;
  departureCheckpoint: DeviceCheckpoint;
  departureTime: DeviceDepartureTime;
  arrivalTime: DeviceArrivalTime;
  arrivalCheckpoint: DeviceCheckpoint;
  currentPosition: DeviceCurrentPosition | null;
  plannedPolyline: DevicePlannedPolyline;
  trackedPolyline: DeviceTrackedPolyline;
};

export type DeviceTrackingDisplaySettings = {
  displayLocationTracking: boolean;
  displayEstimatedTimeOfArrival: boolean;
};

export type DeviceTracking = {
  id: string;
  caseId: string;
  deviceId: string;
  deviceNodes: DeviceNode[];
  arrivalTime: DeviceArrivalTime;
  displaySettings: DeviceTrackingDisplaySettings;
};

export type DeviceTrackingQueryParams = {
  nodesOffsets?: Record<string, number>;
  nodesPlannedEtags?: Record<string, string>;
};

export type CaseArrivalTime = {
  caseId: string;
  arrivalTime: {
    sta: string | null;
    eta: string | null;
  };
  displaySettings: DeviceTrackingDisplaySettings;
};

export type BulkArrivalCustomerResponse = {
  caseArrivalTimes: CaseArrivalTime[];
};
